/** Epoch ms from Firebase `.info/serverTimeOffset` + local clock. Undefined until offset is known. */
export function serverNowMsFromOffset(offsetMs: number | undefined): number | undefined {
    if (offsetMs === undefined) {
        return undefined;
    }
    return Date.now() + offsetMs;
}
